<div class="tenant-list-content">
  <div *ngIf="formatedGroupList.length || loading; else noGroupList">
    <app-table
      [items]="formatedGroupList"
      [loading]="loading"
      [deleteTitle]="tk.Management.TenantTitleDeleteConfirmation | t"
      [headers]="headers"
      [columns]="columns"
      [permissions]="tenantPermissions"
      [totalRecords]="pagination.total"
      [options]="tableOptions"
      [rows]="pagination.itemsPerPage || 10"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableAction)="handleTableAction($event)"></app-table>
  </div>
  <ng-template #noGroupList>
    <div class="tenant-list-content__empty">
      <h4>{{ tk.User.NoProfileRegistered | t }}</h4>

      <div class="tenant-list-content__empty__button" *appHasPermission="tenantPermissions.CREATE">
        <app-button
          [id]="'add-group'"
          [label]="tk.User.ToAdd | t"
          [icon]="'pi pi-plus'"
          [type]="'button'"
          (sendButtonClick)="addTenant()"></app-button>
      </div>
    </div>
  </ng-template>
</div>

<app-dialog
  [key]="'select-user-to-onboarding'"
  [action]="'select-user-to-onboarding'"
  [headerTheme]="'none'"
  [title]="(tk.Onboarding.ChooseUserToSendOnboardingLink | t) || ''">
  <div *ngIf="users?.length" class="user-to-send">
    <div *ngFor="let user of users" class="user-to-send__item">
      <app-user-data-h
        [name]="user.firstName + ' ' + user.surName"
        [email]="user.email"
        [infoContainer]="'row'"
        [action]="{
          action: 'send-onboarding-link',
          label: (tk.Onboarding.SendLink | t) || '',
        }"
        (sendAction)="handleSendAction($event, user)"></app-user-data-h>
    </div>
  </div>
</app-dialog>

<app-dialog
  [key]="'user-to-onboarding-success'"
  [action]="'user-to-onboarding-success'"
  [headerTheme]="'none'"
  [title]="tk.Onboarding.registrationCompleted | t"
  [breakpoints]="{
    '960px': '25vw',
    '640px': '100vw',
  }">
</app-dialog>
